/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DeleteRequestBody,
  DeleteRequestBody$Outbound,
  DeleteRequestBody$outboundSchema,
} from "../components/deleterequestbody.js";

export type DeleteServerNameOverrideSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteServerNameOverrideSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteServerNameOverrideSecurity = {
  option1?: DeleteServerNameOverrideSecurityOption1 | undefined;
  option2?: DeleteServerNameOverrideSecurityOption2 | undefined;
};

export type DeleteServerNameOverrideRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  deleteRequestBody: DeleteRequestBody;
};

/** @internal */
export type DeleteServerNameOverrideSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteServerNameOverrideSecurityOption1$outboundSchema:
  z.ZodMiniType<
    DeleteServerNameOverrideSecurityOption1$Outbound,
    DeleteServerNameOverrideSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteServerNameOverrideSecurityOption1ToJSON(
  deleteServerNameOverrideSecurityOption1:
    DeleteServerNameOverrideSecurityOption1,
): string {
  return JSON.stringify(
    DeleteServerNameOverrideSecurityOption1$outboundSchema.parse(
      deleteServerNameOverrideSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteServerNameOverrideSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteServerNameOverrideSecurityOption2$outboundSchema:
  z.ZodMiniType<
    DeleteServerNameOverrideSecurityOption2$Outbound,
    DeleteServerNameOverrideSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function deleteServerNameOverrideSecurityOption2ToJSON(
  deleteServerNameOverrideSecurityOption2:
    DeleteServerNameOverrideSecurityOption2,
): string {
  return JSON.stringify(
    DeleteServerNameOverrideSecurityOption2$outboundSchema.parse(
      deleteServerNameOverrideSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteServerNameOverrideSecurity$Outbound = {
  Option1?: DeleteServerNameOverrideSecurityOption1$Outbound | undefined;
  Option2?: DeleteServerNameOverrideSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteServerNameOverrideSecurity$outboundSchema: z.ZodMiniType<
  DeleteServerNameOverrideSecurity$Outbound,
  DeleteServerNameOverrideSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteServerNameOverrideSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteServerNameOverrideSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteServerNameOverrideSecurityToJSON(
  deleteServerNameOverrideSecurity: DeleteServerNameOverrideSecurity,
): string {
  return JSON.stringify(
    DeleteServerNameOverrideSecurity$outboundSchema.parse(
      deleteServerNameOverrideSecurity,
    ),
  );
}

/** @internal */
export type DeleteServerNameOverrideRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  DeleteRequestBody: DeleteRequestBody$Outbound;
};

/** @internal */
export const DeleteServerNameOverrideRequest$outboundSchema: z.ZodMiniType<
  DeleteServerNameOverrideRequest$Outbound,
  DeleteServerNameOverrideRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    deleteRequestBody: DeleteRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      deleteRequestBody: "DeleteRequestBody",
    });
  }),
);

export function deleteServerNameOverrideRequestToJSON(
  deleteServerNameOverrideRequest: DeleteServerNameOverrideRequest,
): string {
  return JSON.stringify(
    DeleteServerNameOverrideRequest$outboundSchema.parse(
      deleteServerNameOverrideRequest,
    ),
  );
}
